import React from "react";

export default function Map() {
  return (
    <>
      <iframe

src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2353318646346!2d76.94364490000004!3d11.02096220000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba858dc56eae50d%3A0xdce60415a965fe09!2sKrish%20Tec!5e0!3m2!1sen!2sin!4v1718514451270!5m2!1sen!2sin" 

        allowFullScreen
        title="map"
        width="100%"
        height="375px"
        frameBorder="0"
        className="embed-responsive-item"
      ></iframe>
    </>
  );
}
